module.exports = __webpack_public_path__ + "img/erp.0cea49cc.png";